
export default {
  props: {
    msg: String,
  },
  data() {
    return {
      text: "I`m a text from components",
    };
  },
};
